import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText, MediumText } from '@guryou/html-components';
import { stateIsLoading, useResourcesNew } from '@guryou/redux';
import StaffCount from 'onboard/components/StaffCount';
import SelectableCubeGroup from 'onboard/components/StaffCube';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';
import { dealTokens, SkeletonLoader } from 'components/shared';

import StepButtons from '../StepButtons';

const ServiceStaff = () => {
  const { t } = useTranslation();
  const { serviceState, setServiceState } = useOnboardContext();
  const resources = useResourcesNew();
  const [staffError, setStaffError] = useState(false);
  const [count, setCount] = useState(Number(serviceState.capacity));

  const handleSubmit = data => {
    const resourceIds = data.resources
      ?.split(',')
      .map(item => item.trim())
      .filter(item => item !== '')
      .map(Number);

    const err = resourceIds.length < 1;
    if (err) {
      setStaffError(true);
      return;
    }
    setServiceState({ ...data, resources: resourceIds });
  };

  const preselected = resources?.data && resources.data.length > 0 && [resources?.data[0].id];

  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t('ONBOARD.serviceStaffTitle')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6} flexWrap="wrap">
          {stateIsLoading(resources) ? (
            <SkeletonLoader type="staffCubes" />
          ) : (
            <SelectableCubeGroup
              error={staffError}
              setError={setStaffError}
              resources={resources?.data || []}
              values={serviceState?.resources.length > 0 ? serviceState?.resources : preselected}
            />
          )}

          <StaffCount count={count} setCount={setCount} name="capacity" title={t('ONBOARD.howManyPerStaff')} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText lineHeight="1.3">{t('ONBOARD_TEXT.serviceStaffTitle')}</MediumText>
        <DefaultText color={dealTokens.color.textMuted} marginTop={2}>
          {t('ONBOARD_TEXT.serviceStaffSubtitle')}
        </DefaultText>

        <div style={{ marginTop: dealTokens.space[6], paddingTop: dealTokens.space[5], borderTop: `1px solid ${dealTokens.color.border}` }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: dealTokens.font.weightSemibold,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: dealTokens.color.textMuted,
              marginBottom: dealTokens.space[4],
            }}
          >
            {t('ONBOARD_TEXT.serviceStaffCheckboxTitle')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: dealTokens.space[4] }}>
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceStaffCheckbox1Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceStaffCheckbox2Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceStaffCheckbox3Text')} />
          </div>
        </div>

        <PlayGuideVideoEmbed videoId={guideVideos.serviceStaff.videoId} modalTitle={guideVideos.serviceStaff.title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default ServiceStaff;
